<script setup>
import AppConfig from '~/config/appConfig.js'
import { onBeforeUnmount, onMounted } from 'vue'
import { useDeviceIdentification } from '@/composables/useDeviceIdentification.js'
import { useDataSync } from '@/composables/useDataSync.js'
import { useServiceWorkerState } from '@/composables/useServiceWorkerState.js'
import useStoreVersion from '@/composables/useStoreVersion.js'
import OfflineSupportBanner from '@/components/layout/OfflineSupportBanner.vue'
import { watchForSessionEnd } from '@/helpers/session.js'

const storeVersion = useStoreVersion()
storeVersion.migrate()

const serviceWorkerState = useServiceWorkerState()
serviceWorkerState.refreshServiceWorkerState()
serviceWorkerState.watchState()

const deviceIdentification = useDeviceIdentification()
deviceIdentification.identifyDevice()

// A logout in another tab ends the session here too
watchForSessionEnd()

const dataSync = useDataSync()
dataSync.watchSync()
onBeforeUnmount(() => dataSync.stopWatchSync())

onMounted(() => {
  if (AppConfig.theme != 'sbg' &&localStorage.getItem('header-color') != null) {
    let r = document.querySelector(':root')
    r.style.setProperty('--header-color', localStorage.getItem('header-color'))
    r.style.setProperty('--header-text-color', localStorage.getItem('header-text-color'))
    r.style.setProperty('--footer-icon-color', localStorage.getItem('footer-icon-color'))
    r.style.setProperty(
      '--footer-active-icon-color',
      localStorage.getItem('footer-active-icon-color')
    )
  }
})

</script>

<template>
  <OfflineSupportBanner />
  <RouterView />

  <Toast position="bottom-left" group="bl" />
  <DynamicDialog />
  <div>
    <link rel="stylesheet" :href="`/themes/${AppConfig.theme}-theme/theme.css`" />
  </div>
</template>

<style scoped>
.pwa-toast {
  position: fixed;
  right: 0;
  bottom: 0;
  margin: 16px;
  padding: 12px;
  border: 1px solid #8885;
  border-radius: 4px;
  z-index: 1;
  text-align: left;
  box-shadow: 3px 4px 5px 0 #8885;
  background-color: white;
}
.pwa-toast .message {
  margin-bottom: 8px;
}
.pwa-toast button {
  border: 1px solid #8885;
  outline: none;
  margin-right: 5px;
  border-radius: 2px;
  padding: 3px 10px;
}
</style>
